import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { SectionCard } from "@/components/elements/SectionCard";
import { TCreateOrganizationInitialUserForm } from "@/features/organization/schema/createOrganizationInitialUserSchema";
import { black } from "@/theme/colors";
import { Grid, Stack } from "@mui/material";
import { FC } from "react";
import { Control } from "react-hook-form";

type Props = {
  control: Control<TCreateOrganizationInitialUserForm>;
};

export const OrganizationCreateSetupInitialUser: FC<Props> = ({ control }) => {
  return (
    <Stack gap={3}>
      <SectionCard maxWidth="100%" title="最初に登録するユーザー情報" titleVariant="head20Bold" titleColor={black[30]}>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <FormField control={control} name="userName">
              <Input />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField control={control} name="email">
              <Input />
            </FormField>
          </Grid>
          <Grid item xs={6}>
            <FormField label="権限" required>
              <Input nonControl readonly value="管理者" clearable={false} />
            </FormField>
          </Grid>
        </Grid>
      </SectionCard>
    </Stack>
  );
};
